import { BaseModal } from "@/components/modal/base-modal";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { memo } from "react";
import { GoalOption, GoalSelectModal } from "./goal-select-modal";

interface StandaloneGoalModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  defaultValue: string;
  options: GoalOption[];
  onSelect: (value: string) => void;
}

export const StandaloneGoalModal = memo(function StandaloneGoalModal({
  isOpen,
  onDismiss,
  defaultValue,
  options,
  onSelect,
}: StandaloneGoalModalProps) {
  const viewportHeight = useViewportHeight();
  const handleSelect = (value: string) => {
    onSelect(value);
    onDismiss();
  };

  return (
    <BaseModal isOpen={isOpen} onDismiss={onDismiss} initialBreakpoint={410 / viewportHeight}>
      <GoalSelectModal defaultValue={defaultValue} options={options} onSelect={handleSelect} />
    </BaseModal>
  );
});
